import { Box } from "@mui/material"
import PaymentPage from "../components/PaymentPage"

const RecruitmentPayment=()=>{
    return(
        <Box>
            <PaymentPage/>
        </Box>

    )
}
export default RecruitmentPayment